import { useState, useEffect, useContext } from 'react'
import { lang, img_url, gotoURL, gotoLink, check_brightness } from '../components/lang'
import ThemeContext from '../context/ThemeContext';
import api from '../components/api'
import Slide from '../components/Homepage/Slide'
import classes from '../assets/css/module/layout.module.css';

export default function Home() {
  const [article, setArticle] = useState([]);
  const [config, setConfig] = useState({});
  const { language, page, init } = useContext(ThemeContext);

  useEffect(()=>{
    const fetchInit = async () =>{
        try {
          const response = await api.get('/article/1');
          setArticle(response.data.results);
          // console.log(response.data.results);
          const home_config = JSON.parse(response.data.results.detail);
          setConfig(home_config);
          // console.log(home_config);
          // console.log(response.data.results.detail);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }
    fetchInit();
  },[]);

  return (
    <>
      <div className={classes["homepage"]}>
            <div className={classes["main-slide"]} style={{backgroundImage:'url(/images/th/slide-bg.png)'}}>
                <Slide article={article} classes={classes} />
            </div>
      </div>
    </>
  )
}
